import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { SessaoService } from '../services/sessao.service';
import { AbstractComponent } from '../util/abstract.component';

@Component({
  selector: 'app-segundavia-modal-debito-automatico',
  templateUrl: './segundavia-modal-debito-automatico.component.html',
  styleUrls: ['./segundavia-modal-debito-automatico.component.css']
})
export class SegundaViaModalDebitoAutomaticoComponent extends AbstractComponent implements OnInit {

  constructor(
    private sessaoService: SessaoService,
    public dialogRef: MatDialogRef<SegundaViaModalDebitoAutomaticoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    super(sessaoService);
  }

  ngOnInit() {
    this.dialogRef.disableClose = true;
  }

  /**
   * Fecha a modal de aviso de débito automático
   */
  fechar() {
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/bf-segundavia-cli/segundavia-modal-debito-automatico.component.ts